import React from 'react';
import { useNavigate } from 'react-router-dom'; // Pour la navigation
import './Privacy.css';

const Privacy = () => {
  const navigate = useNavigate(); // Hook pour gérer la navigation

  const handleBack = () => {
    navigate(-1); // Retourne à la page précédente
  };

  return (
    <div className="privacy-container">
      <button className="back-button" onClick={handleBack}>
        ← Retour
      </button>
      <h1 className="privacy-title">Politique de confidentialité</h1>
      <div className="privacy-content">
        <section className="privacy-section">
          <h2>1. Introduction</h2>
          <p>
            Chez DWAG, nous nous engageons à protéger votre vie privée. Cette politique de confidentialité explique comment nous collectons, utilisons, partageons et protégeons vos informations personnelles lorsque vous utilisez notre application de quiz.
          </p>
        </section>

        <section className="privacy-section">
          <h2>2. Informations que nous collectons</h2>
          <p>
            Nous pouvons collecter les informations suivantes :
          </p>
          <ul>
            <li><strong>Informations personnelles</strong> : Lorsque vous créez un compte, nous collectons votre nom d'utilisateur, votre adresse e-mail et, si vous le fournissez, votre nom.</li>
            <li><strong>Données d'utilisation</strong> : Nous collectons des informations sur la manière dont vous utilisez l'application, telles que les quiz auxquels vous participez, vos scores et votre progression.</li>
            <li><strong>Données techniques</strong> : Nous collectons des informations techniques comme votre adresse IP, le type d'appareil, le système d'exploitation et les identifiants de l'appareil.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>3. Utilisation de vos informations</h2>
          <p>
            Nous utilisons vos informations pour :
          </p>
          <ul>
            <li>Fournir et améliorer nos services, notamment en personnalisant votre expérience de quiz.</li>
            <li>Vous envoyer des notifications ou des mises à jour sur l'application.</li>
            <li>Analyser l'utilisation de l'application pour améliorer ses fonctionnalités.</li>
            <li>Assurer la sécurité de l'application et prévenir les fraudes.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>4. Partage de vos informations</h2>
          <p>
            Nous ne vendons ni ne louons vos informations personnelles à des tiers. Cependant, nous pouvons partager vos informations dans les cas suivants :
          </p>
          <ul>
            <li>Avec des prestataires de services qui nous aident à exploiter l'application (par exemple, pour l'hébergement ou l'analyse de données).</li>
            <li>Si requis par la loi ou pour répondre à une demande légale.</li>
            <li>Dans le cadre d'une fusion, d'une acquisition ou d'une vente d'actifs, auquel cas vos informations pourraient être transférées.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>5. Sécurité de vos informations</h2>
          <p>
            Nous mettons en place des mesures de sécurité techniques et organisationnelles pour protéger vos informations contre tout accès non autorisé, perte ou altération. Cependant, aucune méthode de transmission sur Internet ou de stockage électronique n'est totalement sécurisée.
          </p>
        </section>

        <section className="privacy-section">
          <h2>6. Vos droits</h2>
          <p>
            Selon votre juridiction, vous pouvez avoir les droits suivants concernant vos informations personnelles :
          </p>
          <ul>
            <li>Accéder à vos données personnelles et en obtenir une copie.</li>
            <li>Demander la correction ou la suppression de vos données.</li>
            <li>Vous opposer au traitement de vos données ou demander une limitation de ce traitement.</li>
            <li>Retirer votre consentement à tout moment (lorsque le traitement est basé sur le consentement).</li>
          </ul>
          <p>
            Pour exercer ces droits, veuillez nous contacter à <a href="mailto:dwag.contact@gmail.com">dwag.contact@gmail.com</a>.
          </p>
        </section>

        <section className="privacy-section">
          <h2>7. Modifications de cette politique</h2>
          <p>
            Nous pouvons mettre à jour cette politique de confidentialité de temps à autre. Les modifications seront publiées sur cette page, et nous vous informerons des changements importants par e-mail ou via une notification dans l'application.
          </p>
        </section>

        <section className="privacy-section">
          <h2>8. Contact</h2>
          <p>
            Si vous avez des questions ou des préoccupations concernant cette politique de confidentialité, veuillez nous contacter à l'adresse suivante : <a href="mailto:dwag.contact@gmail.com">dwag.contact@gmail.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;